import { createSelector } from "reselect";

export const statusTypeSelector = createSelector(
    state => state.services.statusType,
    state => state
);